import { BatteryFull, BatteryLow, BatteryMedium, BatteryWarning, SignalHigh, SignalLow, SignalMedium, SignalZero } from "lucide-react";
import { cn } from "@/lib/utils";

// GT06 heartbeat (0x13) battery is a 0-6 level (not a %), GSM signal 0-4 —
// see backend/src/gt06_tcp.rs. <=1 battery or <=1 signal is "weak enough to
// flag", not "dead" — 0 on either can be a momentary dip, not a real fault,
// but is still worth surfacing rather than hiding.
export const LOW_BATTERY_THRESHOLD = 1;
export const STALE_CHECKIN_HOURS = 24;

export function isLowBattery(level: number | null | undefined) {
  return level != null && level <= LOW_BATTERY_THRESHOLD;
}

export function isStaleCheckin(lastStatusAt: string | null | undefined, hours = STALE_CHECKIN_HOURS) {
  if (!lastStatusAt) return true;
  return Date.now() - new Date(lastStatusAt).getTime() > hours * 60 * 60 * 1000;
}

export function BatteryBadge({ level, className }: { level: number | null | undefined; className?: string }) {
  if (level == null) {
    return <span className={cn("inline-flex items-center gap-1 text-xs text-muted-foreground", className)}><BatteryWarning className="h-3.5 w-3.5" /> No data</span>;
  }
  const Icon = level <= 1 ? BatteryLow : level <= 3 ? BatteryMedium : BatteryFull;
  const tone = level <= 1 ? "text-destructive" : level <= 3 ? "text-amber-500" : "text-success";
  return (
    <span className={cn("inline-flex items-center gap-1 text-xs", tone, className)}>
      <Icon className="h-3.5 w-3.5" /> {level}/6
    </span>
  );
}

export function SignalBadge({ level, className }: { level: number | null | undefined; className?: string }) {
  if (level == null) {
    return <span className={cn("inline-flex items-center gap-1 text-xs text-muted-foreground", className)}><SignalZero className="h-3.5 w-3.5" /> No data</span>;
  }
  const Icon = level <= 1 ? SignalLow : level <= 2 ? SignalMedium : SignalHigh;
  const tone = level <= 1 ? "text-destructive" : level <= 2 ? "text-amber-500" : "text-success";
  return (
    <span className={cn("inline-flex items-center gap-1 text-xs", tone, className)}>
      <Icon className="h-3.5 w-3.5" /> {level}/4
    </span>
  );
}
